module.exports = __webpack_public_path__ + "static/media/banner.dc64a38c.jpg";